/**
 * @ipc/admin-ui · shared/api/use-tenant — React-хук активного тенанта.
 * useSyncExternalStore подписывается на tenant-store: компоненты перерисуются
 * при смене тенанта. switchTenant меняет тенанта И сбрасывает кэш Query
 * (данные приходят из другой физической БД — старый кэш невалиден).
 */
import { useSyncExternalStore } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getTenantId, setTenantId, subscribeTenant } from './tenant-store';

/** Реактивно возвращает slug активного тенанта. */
export function useTenantId(): string {
  return useSyncExternalStore(subscribeTenant, getTenantId, getTenantId);
}

/**
 * Хук-переключатель тенанта: меняет активный тенант и полностью сбрасывает
 * кэш TanStack Query (иначе на экране останутся данные прежней БД).
 */
export function useSwitchTenant(): (slug: string) => void {
  const queryClient = useQueryClient();
  return (slug: string) => {
    if (slug === getTenantId()) {
      return;
    }
    setTenantId(slug);
    void queryClient.resetQueries();
  };
}
